/* eslint-disable */
const deepGet = (object, keys) => {
    keys = typeof keys === 'string' ? keys.split('.') : keys;
    return keys.reduce((xs, x) => (xs && xs[x] !== null && xs[x] !== undefined ? xs[x] : null), object);
};
export default deepGet;